export * from './Terms';
export { Terms as default } from './Terms';
